import useSWR from 'swr'
import { swrFetcher } from './helpers'
import { Service } from './aboboApiTypes'

type ServiceParams = {
  language?: string
}

export const useServices = (queryParams: ServiceParams) => {
  const { data: response, error } = useSWR(['/services', {queryParams}], swrFetcher<Service[]>, {revalidateOnFocus: false})

  return {
    services: response?.data,
    isLoading: !error && !response,
    isError: error,
  }
}

export const useService = (serviceId: string | undefined, language?: string) => {
  const { data: response, error } = useSWR(
    serviceId ? [`/services/${serviceId}`, { queryParams: { language } }] : null,
    swrFetcher<Service>,
    { revalidateOnFocus: false }
  )

  return {
    service: response?.data,
    isLoading: serviceId ? !error && !response : false,
    isError: error,
  }
}